'use strict'

export default function extractQueryStringParam( url, param ) {
  if (url && url.length > 0 && url.indexOf(param + '=') !== -1) {
    var val = url.split(param + '=')[1].split("&")[0].split("#")[0];
    return (val === '') ? null : val;
  }
  return null;
}
